//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { ColumnModel, FieldModel } from '../api/api.models'

import { LocalizationHelper, IUserSession, DataProvider } from "../../helpers/"

import { Enums } from "../../models/common/"
import { OpLocationType, OpViewColumn, OpView, OpData } from "../../models/core/"
import { SESSION } from '../../models/custom/'
import { OpDataList } from '../../models/util/op-data-list'
import { IOpData, IOpObject } from '../../models/util/interfaces'
import { OpChangeState } from '../../models/common/enums'
import { GetViewColumnOptions } from '../../models/core/op-view'

export class GroupingLocationTypeHelper {

    // Consts

    public static get FILE_NAME_PREFIX(): string { return 'grouping-locations-types' }
    public static get REFERENCE_TYPE(): Enums.ReferenceType { return Enums.ReferenceType.IdLocationType }
    public static get SIMAX_MODULE_NAME(): Enums.SimaxModuleName { return Enums.SimaxModuleName.Grouping_Location_Type }

    // Consts End


    // Methods

    public static createOpObject(locationType: OpLocationType): any {
        const dataList: OpDataList<IOpData> = new OpDataList<IOpData>()
        const descriptionDynamicValue = _.find(locationType.dynamicValues, ((dynamicValue: any) => dynamicValue.Key === 'Description'))
        const isActiveDynamicValue = _.find(locationType.dynamicValues, ((dynamicValue: any) => dynamicValue.Key === 'IsActive'))

        const isActiveData: IOpData = new OpData({
            ID_DATA_TYPE: Enums.DataType.GROUPING_LOCATION_TYPE_IS_ENABLED,
            INDEX_NBR: 0,
            VALUE: isActiveDynamicValue.Value,
            OpState: OpChangeState.Loaded
        })

        const descriptionData: IOpData = new OpData({
            ID_DATA_TYPE: Enums.DataType.HELPER_DESCRIPTION,
            INDEX_NBR: 0,
            VALUE: descriptionDynamicValue.Value,
            OpState: OpChangeState.Loaded
        })

        dataList.push(isActiveData, descriptionData)

        const result: any = {
            dataList,
            dynamicValues: locationType.dynamicValues,
            idObject: locationType.idLocationType,
            name: locationType.name,
            opState: OpChangeState.Loaded,

            getReferenceKey() {
                return locationType.idLocationType
            }
        }

        return result
    }

    public static createOpLocationTypeFromOpObject(opObject: IOpObject): OpLocationType {
        const locationType: OpLocationType = new OpLocationType(null)
        const isActiveData: IOpData = _.find(opObject.dataList.toArray(), (opData: IOpData) => opData.idDataType === Enums.DataType.GROUPING_LOCATION_TYPE_IS_ENABLED)
        const descrptionData: IOpData = _.find(opObject.dataList.toArray(), (opData: IOpData) => opData.idDataType === Enums.DataType.HELPER_DESCRIPTION)

        if (descrptionData != null) {
            locationType.dynamicValues.push({
                Key: 'Description',
                Value: descrptionData.value
            })
        }

        if (isActiveData != null) {
            locationType.dynamicValues.push({
                Key: 'IsActive',
                Value: isActiveData.value
            })
        }

        return locationType
    }

    public static getGroupingLocationTypeGridColumns(): ColumnModel[] {
        const nameColumn: ColumnModel = new ColumnModel()
        const descriptionColumn: ColumnModel = new ColumnModel()
        const isActiveColumn: ColumnModel = new ColumnModel()
        const locationCountColumn: ColumnModel = new ColumnModel()

        nameColumn.idName = 'name'
        nameColumn.name = 'Name'
        nameColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Name)

        descriptionColumn.idName = 'description'
        descriptionColumn.name = 'Description'
        descriptionColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Description)

        isActiveColumn.idName = 'isactive'
        isActiveColumn.name = 'IsActive'
        isActiveColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Active)
        isActiveColumn.type = Enums.DataTypeClass.Boolean

        locationCountColumn.idName = 'locationcount'
        locationCountColumn.name = 'LocationCount'
        locationCountColumn.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.LocationCount)
        locationCountColumn.type = Enums.DataTypeClass.Integer

        return [nameColumn, descriptionColumn, isActiveColumn, locationCountColumn]
    }

    public static getGroupingLocationTypeDetailsFields(locationType: OpLocationType): FieldModel[] {
        const descriptionField: FieldModel = new FieldModel()
        const isActiveField: FieldModel = new FieldModel()

        const descriptionDynamicValue = _.find(locationType.dynamicValues, ((dynamicValue: any) => dynamicValue.Key === 'Description'))
        const isActiveDynamicValue = _.find(locationType.dynamicValues, ((dynamicValue: any) => dynamicValue.Key === 'IsActive'))

        descriptionField.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Description)
        descriptionField.typeId = Enums.DataTypeClass.Text

        isActiveField.caption = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Active)
        isActiveField.typeId = Enums.DataTypeClass.Boolean

        if (descriptionDynamicValue) {
            descriptionField.value = descriptionDynamicValue.Value
        }

        if (isActiveDynamicValue) {
            isActiveField.value = isActiveDynamicValue.Value
        }

        return [descriptionField, isActiveField]
    }

    public static saveGroupingLocationType(dataProvider: DataProvider, oldLocationTypeBusinessObject: any, newLocationType: OpLocationType): JQueryPromise<OpLocationType> {
        const deferred: JQueryDeferred<OpLocationType> = $.Deferred<OpLocationType>()
        const result: OpLocationType = new OpLocationType(null)

        result.idLocationType = oldLocationTypeBusinessObject.getReferenceKey()
        result.opState = OpChangeState.Modified
        result.name = oldLocationTypeBusinessObject.name

        oldLocationTypeBusinessObject.dynamicValues.forEach((oldDynamicValue: { Key: string, Value: any }) => {
            const newDynamicValue: { Key: string, Value: any } = _.find(newLocationType.dynamicValues, (dv: { Key: string, Value: any }) => dv.Key === oldDynamicValue.Key)

            if (newDynamicValue) {
                result.dynamicValues.push(newDynamicValue)
            } else {
                result.dynamicValues.push(oldDynamicValue)
            }
        })

        dataProvider.GroupingLocationType
            .saveGroupingLocationType(result)
            .then((savedObject: OpLocationType) => {
                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                let errorMsg: string = error

                if (SESSION.isType(error)) {
                    errorMsg = (<SESSION>error).toString()
                }

                deferred.reject(errorMsg)
            })

        return deferred.promise()
    }

    public static getLocationTypeViewColumn(userSession: IUserSession): JQueryPromise<OpViewColumn> {

        return userSession.getDataProvider()
            .View.getActiveView(Enums.ReferenceType.IdLocation)
            .then((activeView: OpView) => {
                if (activeView != null) {
                    const options: GetViewColumnOptions = new GetViewColumnOptions(Enums.DataType.HELPER_ID_LOCATION_TYPE)

                    options.keyColumn = activeView.getPrimaryKeyColumn()

                    return activeView.getViewColumn(options)
                }

                return null
            })
    }

    // Methods End
}